import { Component, OnInit } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-score-by-mac',
  templateUrl: './exam-score-by-mac.component.html',
  styleUrls: ['./exam-score-by-mac.component.scss']
})
export class ExamScoreByMacComponent implements OnInit {
  skipImportCandidateData = false;
  excludeTestCandidates = true;

  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  constructor(private popoverRef: PopoverRef<ExamScoreByMacComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer) { }

  async ngOnInit() {

  }

  close() {
    this.popoverRef.close();
  }
  async generateReport() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      const reportTree = this.router.createUrlTree([], {
        queryParams: {
          "examinationID": this.exam.id, "skipImportCandidateData": this.skipImportCandidateData 
          , "excludeTestCandidates": this.excludeTestCandidates
      } });
      let params = this.serializer.serialize(reportTree).split('?', 2)[1];
      await this.examService.examScoreByMAC(params).then((s: IFileDownload) => {
        this.snackBar.success('Report Successfull');
        this.exportedFile = s;
      })
    }
  }

}
